// extracted by mini-css-extract-plugin
module.exports = {"root":"StakeInfoCard_root__yBHf1","apyCard":"StakeInfoCard_apyCard__4_pz6"};